import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import { MapService } from '../../map/services/map.service';

declare var Terraformer: any; // terraformer-wkt-parser.js, https://github.com/esri/terraformer-wkt-parser


/**
 * Component allowing import of AOI locations into a user's saved
 * locations set.
 */
@Component({
	selector: 'import-geo-locations',
	templateUrl: './import-locations.component.html',
	styleUrl: './import-locations.component.css'
})
export class ImportLocationsComponent implements OnInit {
	LOCALIZATION: any;

	geometries: any[] = [];
	uploadFiles: any[] = [];
	uploadStatus: string = "";

	fields: any[] = [];
	fieldToUse: string = "";

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private mapService: MapService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	onFilesSelected(files: File[]) {
		files.forEach(file => {
			console.log('Added file:', file);
			this.addFile(file);
		});
	}

	addFile(file: File): void {
		if (!file) return;

		let ext = file.name.substr(file.name.lastIndexOf('.'));
		if (ext != ".zip") {
			this.alertsService.error({
				title: "Unsupported File",
				message: "The file is in the wrong format. Upload a ZIP file containing one or more Shapefiles."
			});
			return;
		}

		this.uploadFiles = [];
		this.uploadFiles.push(file);
		this.upload();
	}

	removeFile(fileIndex: number): void {
		this.uploadFiles.splice(fileIndex, 1);
	}

	upload(): void {
		this.uploadStatus = "PENDING";
		this.mapService.uploadShapefile(this.uploadFiles[0]).then(
			(data: any) => {
				if (data && data.features) {
					if (data.features.length > 0) {
						this.uploadStatus = "SUCCESS";
						this.geometries = [];
						this.fields = Object.keys(data.features[0].properties);
						this.fieldToUse = this.fields[0];
						for (let i = 0; i < 50; i++) {
							let feature = data.features[i];
							let geo = Terraformer.WKT.convert(feature.geometry);
							let obj = {
								"properties": feature.properties,
								"geo": geo,
								"selected": true
							}
							this.geometries.push(obj);
						}
					} else if (data.features.length == 0) {
						this.uploadStatus = "SUCCESS";
						this.alertsService.info({
							title: "Service Information",
							message: "No features were found in the uploaded file."
						});
					}
				} else {
					this.uploadStatus = "FAILED";
					this.alertsService.error({
						title: "Service Error",
						message: data && data.data ? data.data : "Unable to complete the request."
					});
				}
			},
			(err: any) => {
				console.error("Failed to upload file.", err);
				this.uploadStatus = "FAILED";
				this.alertsService.error({
					message: "Error processing file upload."
				});
			}
		);
	}

	/**
	 * Saves the selected geo data locations.
	 */
	save(): void {
		for (let i = 0; i < this.geometries.length; i++) {
			if (this.geometries[i].selected) {
				let payload = {
					geo: this.geometries[i].geo,
					name: this.geometries[i].properties[this.fieldToUse]
				};

				this.mapService.addLocation(payload).then(
					(response: any) => { },
					(err: any) => {
						console.error("Failed to add location", err);
					}
				);
			}
		}
		this.alertsService.success({
			title: "Locations saved",
			message: "Successfully saved locations."
		});

		this.proceed();
	}

	toggleGeometries(all: boolean): void {
		for (let i = 0; i < this.geometries.length; i++) {
			this.geometries[i].selected = all;
		}
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'geoImport'
		};

		this.ngbmodalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
